import { useEffect, useRef } from 'react'

const useFocusTrap = () => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const getFocusableElements = () => {
      return Array.from(
        containerRef.current?.querySelectorAll(
          'a, button:not([tabindex="-1"]), input:not([readonly]):not([tabindex="-1"]), textarea:not([readonly]):not([tabindex="-1"]), select:not([readonly]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"]), .MuiAutocomplete-input:not([readonly]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), .switch-element'

          // 'a, button:not([tabindex="-1"]), input:not([readonly]):not([tabindex="-1"]), textarea:not([readonly]):not([tabindex="-1"]), select:not([readonly]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"]), .MuiAutocomplete-input:not([readonly])'
        ) || []
      ) as HTMLElement[]
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      const focusableElements = getFocusableElements()

      if (focusableElements.length > 0 && event.key === 'Tab') {
        event.preventDefault()

        const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement)

        const nextIndex =
          (event.shiftKey ? currentIndex - 1 + focusableElements.length : currentIndex + 1) % focusableElements.length

        focusableElements[nextIndex]?.focus()
      }

      if (event.key === 'Enter') {
        event.preventDefault()

        const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement)

        if (event.shiftKey) {
          const prevIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length

          focusableElements[prevIndex].focus()
        } else {
          const nextIndex = (currentIndex + 1) % focusableElements.length

          focusableElements[nextIndex].focus()
        }
      }
    }

    const container = containerRef.current

    if (container) {
      // Set tabindex untuk elemen tertentu jika diperlukan
      const manuallyFocusable = container.querySelectorAll(
        'button[tabindex="-1"], .MuiAutocomplete-clearIndicator[tabindex="-1"]'
      )

      manuallyFocusable.forEach(el => {
        ;(el as HTMLElement).setAttribute('tabindex', '0')
      })

      // Hindari fokus pada elemen readonly
      const readonlyElements = container.querySelectorAll(
        'input[readonly], textarea[readonly], select[readonly], .MuiAutocomplete-input[readonly], .MuiTableCell-root'
      )

      readonlyElements.forEach(el => {
        ;(el as HTMLElement).setAttribute('tabindex', '-1')
      })
    }

    // Tambahkan event listener
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      // Bersihkan event listener
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return containerRef
}

export default useFocusTrap
